<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:head-actions>
      <button
        @click="$router.push('/invoices/off-course/create')"
        class="px-4 py-2 rounded"
        style="background-color: #75a045"
      >
        + New Invoice
      </button>
    </template>
    <template v-slot:table-heading>
      <th class="p-2">Invoice #</th>
      <th class="p-2">Patient Name</th>
      <th class="p-2">Visit Type</th>
      <th class="p-2">Insurer</th>
      <th class="p-2">Total</th>
      <th class="p-2">Actions</th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td class="p-2">{{ user.invoice_number }}</td>
        <td class="p-2">{{ user.patient_name }}</td>
        <td class="p-2">{{ user.visit_type }}</td>
        <td class="p-2">{{ user.insurer_name }}</td>
        <td class="p-2">{{ user.total_amount }}</td>
        <td class="p-2">
          <button
            @click="$router.push('/invoices/off-course/view/' + user.id)"
            class="bg-green-500 text-white px-2 py-1 rounded"
            style="background-color: #75a045"
          >
            View
          </button>
          <button
            style="background-color: red"
            @click="$router.push('/invoices/off-course/edit/' + user.id)"
            class="bg-yellow-500 text-white px-2 py-1 rounded ml-2"
          >
            Edit
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BaseLayout from "../../Patients/components/table_page_layout.vue";
// import formatDateTime from "../../timezone/utc_local_time.js";
import formatDateTime from "../../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "searchCompanyUsers",
      mainUrl: "invoices/offcourse/",
    };
  },
  components: {
    BaseLayout,
    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>

<!-- ===================================================================================== -->
